import { render, staticRenderFns } from "./PropertySelections.vue?vue&type=template&id=ff318742"
import script from "./PropertySelections.vue?vue&type=script&lang=js"
export * from "./PropertySelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports